// extracted by mini-css-extract-plugin
export var centerList = "_hf-6";
export var centerLoc = "_hf-a";
export var centerName = "_hf-9";
export var centerOptionBody = "_hf-8";
export var centerRow = "_hf-7";
export var centerStatus = "_hf-b";
export var empty = "_hf-5";
export var externalIcon = "_hf-c";
export var fieldHeader = "_hf-2";
export var fieldHelp = "_hf-4";
export var fieldLabel = "_hf-3";
export var panel = "_hf-0";
export var removeBtn = "_hf-d";
export var section = "_hf-1";